class Loader {

	constructor(params){

		this.params = params

		this.loadQueue = [];
		this.totalLoadItems;
		this.currentLoadItem;
		this.nextLoadItem;

		this.xhr;

		this.autoStart = this.params && this.params.autoStart !== false;
		this.onCompleteCallback = this.params && _.isFunction(this.params.onCompleteCallback) ? this.params.onCompleteCallback : null;
		this.onCancelCallback = this.params && _.isFunction(this.params.onCancelCallback) ? this.params.onCancelCallback : null;
		this.isLoading = false;
	}

	// public methods

	addToQueue(a, b, c){

		if(this._validateQueueItem(a, b)){

			// single item (url, callback, pushToFront)

			let obj = {
				url: a,
				callback: b
			};

			this._addItemToQueue(obj, c);
		}
		else if($.isPlainObject(a) && this._validateQueueItem(a.url, a.callback)){
			// single item (object containing url, callback, pushToFront, additional params)
			this._addItemToQueue(a, a.pushToFront);
		}
		else if($.isArray(a)){

			// array of items

			for(let i=0; i<a.length; i++){

				let obj = a[i];
				let queueObj = Object.assign({}, obj);
				delete queueObj.pushToFront;

				if(this._validateQueueItem(obj.url, obj.callback)){
					this._addItemToQueue(queueObj, obj.pushToFront);
				}
			}
		}
	}

	emptyQueue(){
		this.stop();
		this.loadQueue = [];
	}

	start(){
		this.totalLoadItems = this.loadQueue ? this.loadQueue.length : 0;
		this._nextLoadItem();
	}

	stop(){

		if(this.xhr){
			this.xhr.abort();
			this.xhr = null;
		}

		this.isLoading = false;

		if(this.onCancelCallback){
			this.onCancelCallback.apply(null, []);
		}
	}

	// internal methods

	_validateQueueItem(url, callback){
		return (typeof url === 'string' || url instanceof String) && ($.isFunction(callback) || !callback);
	}

	_addItemToQueue(obj, pushToFront){

		let isSuccess = false;

		if(pushToFront === true){
			this.loadQueue.unshift(obj);
			isSuccess = true;
		}
		else {
			this.loadQueue.push(obj);
			isSuccess = true;
		}

		if(isSuccess){
			if(!this.isLoading && this.autoStart){
				this.start();
			}
		}
	}

	_nextLoadItem(){
		if(this.nextLoadItem){ this._loadQueueItem(this.nextLoadItem); }
		else if(this.loadQueue.length){ this._loadQueueItem(this.loadQueue[0]); }
	}

	_loadQueueItem(obj){

		if(obj && obj.url){
			if(!this.currentLoadItem){

				this.nextLoadItem = null;
				this.currentLoadItem = obj;
				this.isLoading = true;

				// complete

				let onLoadComplete = (e, isSuccess) => {

					let pos = this.loadQueue.indexOf(this.currentLoadItem);
					if(pos >= 0){ this.loadQueue.splice(pos, 1); }

					if(this.currentLoadItem.callback && _.isFunction(this.currentLoadItem.callback)){
						this.currentLoadItem.callback.apply(null, [{
							originalEvent:e,
							data: e.data,
							success: isSuccess,
							loadItem: this.currentLoadItem,
							progress: this.loadQueue.length > 0 ? 1 - this.loadQueue.length/this.totalLoadItems : 1
						}]);
					}

					this.currentLoadItem = null;
					this._checkCompleteStatus();

					if(this.loadQueue.length){
						// need delay or computer will explode
						window.setTimeout(() => {
							this._nextLoadItem();
						}, 20);
					}
				}

				// ajax call

				this.xhr = $.ajax({

					type: 'GET',
					url: this.currentLoadItem.url,
					async: false,
					dataType: 'text',
					success: (data) => {
						onLoadComplete({data:data}, true);
					},
					error: (e) => {

						console.log("Loader Error");
						console.log(e.message);
						console.log(this.loadQueue);

						onLoadComplete(e, false);
					}
				});
			}
			else {
				this.nextLoadItem = obj;
			}
		}
	}

	_checkCompleteStatus(){
		if(!this.loadQueue.length && this.isLoading){
			this.isLoading = false;
			if(this.onCompleteCallback){
				this.onCompleteCallback.apply(null, []);
			}
		}
	}
}

module.exports = Loader;
